function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { pushProjectDemo } from "@/api/demo/project";
import { DemoType } from "@/api/demo/type";
import { definePropType } from "@types-vue/props";
import { defineComponent, ref, reactive, computed, watch } from "vue";
import { Message } from "element-ui";
import AdvertiserSelector from "@/components/AllAdvertiserSelector/index.vue";
export default defineComponent({
    name: "ProjectDemoPushDialog",
    props: {
        project: {
            type: definePropType(Object),
            required: true
        },
        type: {
            type: definePropType(String),
            default: DemoType.PLAYABLE
        }
    },
    setup: function setup(props) {
        var reset = function reset() {
            var _$ref;
            (_$ref = schemaForm.value) === null || _$ref === void 0 ? void 0 : _$ref.resetFields();
            showResult.value = false;
            model.value = {
                name: props.project.name,
                adv_name: ""
            };
        };
        var showDialog = function showDialog() {
            visible.value = true;
        };
        var submit = function submit() {
            var _$ref;
            (_$ref = schemaForm.value) === null || _$ref === void 0 ? void 0 : _$ref.validate(function(valid) {
                if (valid) {
                    handlePush(props.project);
                }
            });
        };
        var cancel = function cancel() {
            visible.value = false;
        };
        var handlePush = function handlePush(row) {
            loading.value = true;
            pushProjectDemo(_objectSpread({
                id: row.id,
                type: props.type
            }, model.value)).then(function() {
                Message.success("\u63A8\u9001\u6210\u529F");
                visible.value = false;
            }).finally(function() {
                loading.value = false;
            });
        };
        var schemaForm = ref();
        var visible = ref(false);
        var loading = ref(false);
        var showResult = ref(false);
        var formConfig = reactive({
            labelWidth: "165px"
        });
        var model = ref({
            name: "",
            adv_name: ""
        });
        var schema = computed(function() {
            return {
                type: "object",
                properties: {
                    adv_name: {
                        label: "\u5E7F\u544A\u4E3B\u540D\u79F0",
                        component: AdvertiserSelector,
                        field: {
                            clearable: true,
                            filterable: true,
                            collapseTags: true,
                            valueKey: "name"
                        },
                        rules: [
                            {
                                required: true,
                                message: "\u8BF7\u8F93\u5165\u5E7F\u544A\u4E3B\u540D\u79F0",
                                trigger: "blur"
                            }, 
                        ]
                    },
                    name: {
                        label: "\u9879\u76EE\u540D\u79F0",
                        component: "input",
                        rules: [
                            {
                                required: true,
                                message: "\u8BF7\u8F93\u5165\u9879\u76EE\u540D\u79F0",
                                trigger: "blur"
                            }, 
                        ]
                    }
                }
            };
        });
        watch(function() {
            return visible.value;
        }, function(val) {
            if (val) {
                reset();
            }
        });
        return {
            loading: loading,
            schemaForm: schemaForm,
            formConfig: formConfig,
            model: model,
            schema: schema,
            visible: visible,
            showDialog: showDialog,
            submit: submit,
            cancel: cancel
        };
    }
});
